<div class="details" *ngIf="irbNumber">
  <div class="toggle-div">
    <a (click)="toggleSection()">
      <span *ngIf="!isAllExpanded(filteredSections)"> Open all</span>
      <span *ngIf="isAllExpanded(filteredSections)"> Collapse all</span>
    </a>
  </div>

  <mat-accordion multi="true">
    <ng-container *ngFor="let section of filteredSections">
      <mat-expansion-panel [(expanded)]="section.isExpanded">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ section.title }}</mat-panel-title>
        </mat-expansion-panel-header>

        <ng-container [ngSwitch]="section.id">

          <div *ngSwitchCase="1">
            <rpc-status  [irbNumber]="irbNumber"></rpc-status>
          </div>

          <div *ngSwitchCase="2">
            <rpc-accrual [irbNumber]="irbNumber"></rpc-accrual>
          </div>

          <div *ngSwitchCase="3">
            <rpc-protocol-materials [irbNumber]="irbNumber" [hideTitle]="true"
              [isCancerRelatedStudy]="isCancerRelatedStudy">
            </rpc-protocol-materials>
          </div>

          <div *ngSwitchCase="4">
            <div class="padding-left-2-percent">
              <p>{{ diseaseGroup || 'No results found' }}</p>
            </div>
          </div>

          <div *ngSwitchCase="5">
            <div class="padding-left-2-percent">
              <p>{{ diseaseTeam }}</p>
            </div>
          </div>

          <div *ngSwitchCase="6">
            <div class="padding-left-2-percent">
              <p>{{ priority || 'No results found' }}</p>
            </div>
          </div>

          <div *ngSwitchCase="7">
            <div class="padding-left-2-percent">
              <ng-container *ngIf="linesOfTherapy && linesOfTherapy.length > 0; else empty">
                <ol>
                  <li *ngFor="let path of linesOfTherapy">{{ path }}</li>
                </ol>
              </ng-container>
              <ng-template #empty>
                <span>No results found</span>
              </ng-template>
            </div>
          </div>
        </ng-container>
      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>
</div>